import classNames from 'classnames'
import { useCallback, useId } from 'react'
import { ControlFieldAlign } from '../../../types'
import { useControlAriaAttributes } from '../hooks'
import styles from './RadioButton.module.scss'
import type { RadioButtonProps } from '.'

const RadioButton: React.FC<RadioButtonProps> = ({
  align = ControlFieldAlign.left,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  checked,
  className,
  disabled,
  error = false,
  label,
  onChange,
}: RadioButtonProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e.target.checked)
    },
    [onChange]
  )

  const uniqueId = useId()
  const { ariaAttributes } = useControlAriaAttributes({ ariaLabel, ariaLabelledBy, label, labelId: uniqueId })

  return (
    <div className={classNames(styles['pintxo-radio-button'], className)} data-align={align}>
      <input
        type="radio"
        disabled={disabled}
        checked={checked}
        onChange={handleChange}
        data-checked={checked}
        data-disabled={disabled}
        data-error={error}
        className={styles['pintxo-radio-button__input']}
        {...ariaAttributes}
      />
      {label && (
        <span
          className={styles['pintxo-radio-button__label']}
          data-disabled={disabled}
          id={uniqueId}
        >
          {label}
        </span>
      )}
    </div>
  )
}
export default RadioButton
